import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-dialog-confirmation',
  templateUrl: './finish-exam-confirmation.component.html',
})
export class FinishExamConfirmationComponent implements OnInit {

  constructor(
    public dialog: MatDialogRef<FinishExamConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public mensaje: string) { }

  closeDialog() {
    this.dialog.close(false);
  }

  confirm() {
    this.dialog.close(true);
  }

  ngOnInit() { }

}
